import axios from './axios';



// Login user
export const loginUser = (credentials) => {
  return axios.post('/login', credentials);
};
